<template>
    <div class="py-4 bg-secondary">
        <div class="profile-page">
            <section class="section-new">
                <div class="container">
                    <el-row>
                        <el-col :span="24">
                            <div class="card card-lift shadow border-0 card-address_page mb-3">
                                <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                    <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                    <el-breadcrumb-item :to="{ path: '/xalqaro_hamkorlik' }">{{$t('menu.xalqaro')}}
                                    </el-breadcrumb-item>
                                    <el-breadcrumb-item>{{$t('submenu.x_hujjatlar')}}</el-breadcrumb-item>
                                </el-breadcrumb>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </section>
            <section class="section py-3">
                <div class="container">
                    <card shadow class="card-profile mt--100 card_radius_no" no-body style="z-index: 10;">
                        <div class="px-4">
                            <div class="text-center mt-5">
                                <div class="h6 mt-4">
                                    <i class="ni business_briefcase-24 mr-2"></i>
                                    <span class="news_title">
                                        <strong>{{$t('xalqaro.xalqaro_title')}}</strong>
                                        <strong v-if="$i18n.locale === 'uz-UZ'">{{news.titleUzLat}}</strong>
                                        <strong v-if="$i18n.locale === 'uz-CYR'">{{news.titleUz}}</strong>
                                        <strong v-if="$i18n.locale === 'ru-RU'">{{news.tilteRu}}</strong>
                                        <strong v-if="$i18n.locale === 'en-US'">{{news.titleEn}}</strong>
                                    </span>
                                </div>
                            </div>
                            <div class="mt-5 py-5 border-top text-center">
                                <div class="row justify-content-center">
                                    <div class="col-lg-11">
<!--                                        <p style="text-align: justify;" class="new_responsive" v-html="newsContent"></p>-->
                                        <p style="text-align: justify;" class="new_responsive">{{$t('xalqaro.xalqaro_viewtext')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                news: {},
                newsContent: ""
            }
        },
        methods: {
            loadTheNews() {
                let newsId = this.$route.query.id;
                this.$axios.get(`https://www.prokuratura.uz/api/news/detail/${newsId}`).then(response => {
                    switch (this.$i18n.locale) {
                        case "uz-UZ":
                            this.newsContent = response.data.textUzLat.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            break;
                        case "uz-CYR":
                            this.newsContent = response.data.textUz.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            break;
                        case "ru-RU":
                            this.newsContent = response.data.textRu.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            break;
                        case "en-US":
                            this.newsContent = response.data.textEn.replace(/172.18.35.30:8080/g, 'www.prokuratura.uz');
                            break;
                    }
                    this.news = response.data;
                });
            }
        },
        created() {
            this.loadTheNews();
        }
    }
</script>
<style>
    @import url(../assets/css/custom.scss);
/*.new_responsive p img{*/
/*    width:100% !important;*/
/*    display: block;*/
/*}*/
/*.new_responsive div img{*/
/*    width:100% !important;*/
/*    display: block;*/
/*}*/
</style>
